
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.928 2.081h-1.067v7.887a.544.544 0 01-.533.554H2.543v1.107h8.785c.884 0 1.6-.744 1.6-1.661V2.081z","fill":"#515358"}}),_c('g',{attrs:{"fill-rule":"nonzero","stroke":"#515358","stroke-linecap":"square","stroke-width":"1.2"}},[_c('path',{attrs:{"d":"M11.444 2.674h-.572M3.147 10.696V10.1"}})]),_c('path',{attrs:{"d":"M10.06 8.122V1.108C10.06.496 9.581 0 8.992 0H1.067C.477 0 0 .496 0 1.108v7.014C0 8.734.478 9.23 1.067 9.23h7.926c.589 0 1.066-.496 1.066-1.108zM5.093 6.429a1.35 1.35 0 01-1.955 0L1.973 5.222l.754-.783 1.162 1.208a.32.32 0 00.452 0l2.99-3.105.753.78-2.99 3.107z","fill":"#515358","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/invertSelection.svg